<template>
  <div v-if="dialogVisible" class="coze-api-chat-container">
    <!-- 聊天窗口 -->
    <div class="chat-dialog right-side-dialog">
      <div class="dialog-header">
        <h3>芪巢健康-营养膳食AI大模型</h3>
        <button @click="closeDialog" class="close-btn">×</button>
      </div>
      <div class="chat-messages" ref="messagesContainer">
        <div 
          v-for="(message, index) in messages" 
          :key="index" 
          :class="['message', message.role === 'user' ? 'user-message' : 'assistant-message']"
        >
          <div class="message-content">
            <div v-if="message.role === 'assistant' && message.contentType === 'image'" class="image-message">
              <img :src="message.content" alt="图片" />
            </div>
            <div v-else class="text-message" v-html="md.render(message.content)"></div>
          </div>
        </div>
        <!-- 流式输出显示 -->
        <div v-if="streamingMessage" class="message assistant-message">
          <div class="message-content">
            <div class="text-message" v-html="md.render(streamingMessage)"></div>
          </div>
        </div>
      </div>
      <div style="font-size: 20px; color: white; ;text-align: center;padding:10px">
        内容由Ai大模型生成，仅供参考
      </div>

      <!-- <div class="chat-input-area">
        <input 
          v-model="userInput" 
          @keyup.enter="sendMessage" 
          placeholder="请输入您的问题..." 
          class="chat-input"
          :disabled="isLoading"
        />
        <button @click="sendMessage" :disabled="isLoading" class="send-btn">
          {{ isLoading ? '发送中...' : '发送' }}
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it';

// 创建一个安全的 Markdown 解析器实例
const createSafeMarkdownParser = () => {
  return new MarkdownIt({
    html: false,        // 禁用 HTML 标签
    xhtmlOut: false,    // 不使用 XHTML 标签
    breaks: true,       // 转换 \n 为 <br>
    linkify: true,      // 自动识别链接
    typographer: true,  // 启用语言学替换
  });
};

export default {
  name: 'CozeApiChat',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customer_name: {
      type: String,
      default: '客户'
    },
  },
  data() {
    return {
      dialogVisible: false,
      messages: [],
      userInput: '',
      isLoading: false,
      streamingMessage: '', // 用于流式输出的消息
      conversationId: null,
      botId: '7570730922740514858',
      token: 'pat_JzpuP3BLUDmGceOqPYGOMeX2l8WiSm0fxYvFUSYaFsevfP48D0E4OEGs338mxwSv',
      customer_id: this.customer_id, // 使用props传入的customer_id作为默认值
      currentRequestController: null, // 用于控制当前请求
      md: createSafeMarkdownParser(), // Markdown 解析器实例
      isNew:true,
      autoCloseTimer: null // 用于5分钟自动关闭的定时器
    }
  },
  watch: {
    visible: function(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        // 初始化对话
        this.initializeChat();
      }
    },
    customer_id: function(newVal) {
      // 当外部传入的customer_id变化时，更新内部的customer_id
      this.customer_id = newVal;
    }
  },
  
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  },
  methods: {
    closeDialog() {
      console.log('closeDialog --- 关闭聊天框')
      // 清除自动关闭定时器
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      
      this.dialogVisible = false;
      this.$emit('close');
    },
    
    initializeChat() {
      // 清空消息历史
      this.messages = [];
      this.streamingMessage = '';
      
      // 生成唯一的会话ID
      this.conversationId = `${this.customer_id}_${Date.now()}`;
      
      // 清除之前的定时器
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      
      // 设置5分钟后自动关闭聊天框
      this.autoCloseTimer = setTimeout(() => {
        this.closeDialog();
      }, 5 * 60 * 1000); // 5分钟 = 5 * 60 * 1000毫秒
    },
    
    async sendMessage() {
      if (!this.userInput.trim() || this.isLoading) return;
      
      // 添加用户消息到聊天记录
      const userMessage = {
        role: 'user',
        content: this.userInput,
        contentType: 'text'
      };
      this.messages.push(userMessage);
      
      // 保存用户输入并清空输入框
      const question = this.userInput;
      this.userInput = '';
      this.isLoading = true;
      this.streamingMessage = '';
      
      try {
        // 调用扣子API
        await this.callCozeAPI(question);
      } catch (error) {
        // 如果是由于请求被取消导致的错误，则不显示错误信息
        if (error.name === 'AbortError') {
          console.log('请求已被取消');
          return;
        }
        
        console.error('调用扣子API失败:', error);
        this.messages.push({
          role: 'assistant',
          content: '抱歉，我遇到了一些问题，请稍后再试。',
          contentType: 'text'
        });
      } finally {
        this.isLoading = false;
        this.streamingMessage = '';
        // 清理当前请求控制器
        this.currentRequestController = null;
        // 滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    
    async callCozeAPI(question) {
      // 如果有正在进行的请求，先取消它
      if (this.currentRequestController) {
        this.currentRequestController.abort();
      }
      
      // 创建AbortController用于控制请求
      this.currentRequestController = new AbortController();
      const { signal } = this.currentRequestController;
      
      // 构建请求参数
      const requestBody = {
        "bot_id": this.botId,
        "user_id": this.customer_id,
        // conversation_id: this.conversationId,
        "stream": true, // 启用流式输出
        "parameters": {
          "customer_name": this.customer_name,
          "customer_id": this.customer_id
        },
        "query": question,
        "additional_messages": [
          {
            "role": "user",
            "content": question,
            "content_type": "text"
          }
        ]
      };
      console.log('发送的请求体:', JSON.stringify(requestBody, null, 2));
      try {
        const response = await fetch('https://api.coze.cn/v3/chat', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            'Accept': 'text/event-stream'
          },
          body: JSON.stringify(requestBody),
          signal // 将signal添加到请求中
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // 处理流式响应
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        var assistantMessage = '';
        
        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          const value = result.value;
          if (done) break;
          
          buffer += decoder.decode(value, { stream: true });
          
          // 处理接收到的数据块
          const lines = buffer.split('\n');
          buffer = lines.pop(); // 保留最后一个不完整的行
          
          for (const line of lines) {
            // console.log('line---', line);
            if (line.startsWith('data:')) {
              const data = line.slice(5).trim(); // 移除"data:"前缀
              if (data === '[DONE]') {
                // 流结束
                // 对话完成，将完整消息添加到消息列表
                if (assistantMessage) {
                  this.messages.push({
                    role: 'assistant',
                    content: assistantMessage,
                    contentType: 'text'
                  });
                  assistantMessage = '';
                  this.streamingMessage = '';
                }
                break;
              }
              
              try {
                const jsonData = JSON.parse(data);
                // 处理不同类型的消息
                console.log('对话内容:', jsonData);
                
                // 根据实际返回的数据结构调整处理逻辑
                if (jsonData.type === 'answer') {
                  // 处理流式消息增量
                  if (jsonData.content) {
                    assistantMessage += jsonData.content;
                    this.streamingMessage = assistantMessage;
                    // 滚动到底部以显示最新的流式内容
                    this.$nextTick(() => {
                      this.scrollToBottom();
                    });
                  }
                } else if (jsonData.status && jsonData.status == "completed") {
                  // 对话完成，将完整消息添加到消息列表
                  if (assistantMessage) {
                    this.messages.push({
                      role: 'assistant',
                      content: assistantMessage,
                      contentType: 'text'
                    });
                    // assistantMessage = '';
                    // this.streamingMessage = '';
                  }
                } else if (jsonData.event === 'done') {
                  console.log('处理完成事件')
                  // 处理完成事件 
                  if (assistantMessage) {
                    this.messages.push({
                      role: 'assistant',
                      content: assistantMessage,
                      contentType: 'text'
                    });
                    assistantMessage = '';
                    this.streamingMessage = '';
                  }
                  break;
                }
                // 忽略其他事件类型，但保持连接开放以接收更多数据
              } catch (parseError) {
                console.warn('解析JSON数据时出错:', parseError);
              }
            }
          }
        }
      } catch (error) {
        // 如果是由于请求被取消导致的错误，则不显示错误信息
        if (error.name === 'AbortError') {
          console.log('请求已被取消');
          return;
        }
        
        console.error('调用扣子API时出错:', error);
        throw error;
      }
    },
    
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    /**
     * 对外提供的方法，用于显示聊天框并自动发送消息
     * @param {String} content - 要发送的消息内容
     * @param {String} customerId - 客户ID
     */
    showAndSendMessage(content, customerId) {
      // 如果有正在进行的请求，先取消它
      if (this.currentRequestController) {
        this.currentRequestController.abort();
        this.currentRequestController = null;
      }
      
      // 显示聊天框
      this.dialogVisible = true;
      
      // 如果传入了customerId，则更新customer_id
      if (customerId) {
        this.customer_id = customerId;
      }
      
      // 初始化对话（这会清空之前的聊天记录）
      this.initializeChat();
      
      // 设置要发送的内容
      this.userInput = content;
      
      // 自动发送消息
      this.$nextTick(() => {
        this.sendMessage();
      });
    },

    /**
     * 对外提供的方法，用于接收外部消息并直接显示
     * @param {Object} message - 要显示的消息对象，应包含role和content属性
     * @param {String} customerId - 客户ID（可选）
     */
    addExternalMessage(message, customerId) {
      // 显示聊天框
      this.dialogVisible = true;
      
      if(this.isNew){
        this.isNew = false
        this.initializeChat();
        console.log('change -> isNew -- NO')
      }

      // 如果传入了customerId，则更新customer_id
      if (customerId) {
        this.customer_id = customerId;
      }
      
      // 如果还没有初始化对话，则初始化
      // if (!this.conversationId) {
      //   this.initializeChat();
      // }
      
      // 处理流式内容推送
      if (message && message.role && message.content !== undefined) {
        console.log('addExternalMessage 接收到消息:', message);
        // 如果是流式消息（没有完整结束标识），则追加到流式消息内容
        if (message.isStreaming || !message.isComplete) {
          // 追加内容而不是覆盖
          this.streamingMessage += message.content;
        } else {
          // 如果是完整消息或流式结束消息，则添加到消息记录中
          // 检查最后一条消息是否为同一角色的流式消息，如果是则替换，否则添加新消息
          const lastMessage = this.messages[this.messages.length - 1];
          if (lastMessage && lastMessage.role === message.role && this.streamingMessage) {
            // 替换最后一条消息，使用流式消息的累积内容加上当前消息的内容
            const combinedContent = this.streamingMessage + message.content;
            this.messages[this.messages.length - 1] = {
              role: message.role,
              content: combinedContent,
              contentType: message.contentType || 'text'
            };
            
            // 清空流式消息
            console.log('清空流式消息');
            this.streamingMessage = '';
            this.isNew = true;
            console.log('change -> isNew')
          } else {
            console.log('添加新的完整消息');
            this.isNew = true;
            console.log('change -> isNew')
            // 添加新消息
            this.messages.push({
              role: message.role,
              content: message.content,
              contentType: message.contentType || 'text'
            });
          }
        }
        
        // 滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } else {
        console.log('接收到无效消息:', message);
      }
    }
  }
}
</script>

<style scoped>
.coze-api-chat-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.chat-dialog {
  position: fixed;
  right: 0;
  top: 0;
  width: 450px;
  height: 1080px;
  background: #ff7e66;
  display: flex;
  flex-direction: column;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.3);
  z-index: 2001;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: #ff7e66;
}

.dialog-header h3 {
  margin: 0;
  color: #ffffff;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #ffffff;
}

.chat-messages {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background: rgba(242, 59, 33, 0.3);
}

.message {
  margin-bottom: 15px;
  display: flex;
}

.user-message {
  justify-content: flex-end;
}

.assistant-message {
  justify-content: flex-start;
}

.message-content {
  max-width: 90%;
  padding: 10px 15px;
  border-radius: 18px;
  word-wrap: break-word;
  font-size: 25px;
  color: #ffffff;
}

.user-message .message-content {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-bottom-right-radius: 4px;
  font-size: 25px;
}

.assistant-message .message-content {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-bottom-left-radius: 4px;
  font-size: 25px;
}

.image-message img {
  max-width: 100%;
  border-radius: 10px;
}

.chat-input-area {
  display: flex;
  padding: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(242, 59, 33, 0.9);
}

.chat-input {
  flex: 1;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  outline: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.send-btn {
  margin-left: 10px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  cursor: pointer;
}

.send-btn:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
}

/* 右侧对话框样式 */
.right-side-dialog {
  position: fixed;
  right: 0;
  top: 0;
  margin: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>